export default "__VITE_ASSET__BiF4eHQc__"